export const URI_ACCOUNT = 'auth/account';
export const URI_ACCOUNT_UPDATE = 'auth';
